﻿import {translation} from "@2d-front-monorepo/core";
import {ReservationStatusType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {Link, useNavigate} from "react-router";
import {cancelReservation} from "../../../hooks/cancelReservation";
import {formatRoute, PrivateRoutes} from "../../../routes";
import {ReservationMenuProps} from "../../Registrations";

export default function DefaultReservationMenu(props: ReservationMenuProps): JSX.Element {
	const {reservation} = props;
	const navigate = useNavigate();
	const viewUrl = formatRoute(PrivateRoutes.reservationView, reservation.id);
	const cancelEnabled =
		reservation.status.type === ReservationStatusType.Submitted ||
		reservation.status.type === ReservationStatusType.UnderReview ||
		reservation.status.type === ReservationStatusType.Quoted ||
		reservation.status.type === ReservationStatusType.ReSubmitted;

	return <>
		<Link to={viewUrl}>{translation(PermitTranslations.view)}</Link>

		{cancelEnabled &&
            <button onClick={() => cancelReservation(reservation, navigate)}>
				{translation(PermitTranslations.summary_page__cancel_reservation)}
            </button>
		}
	</>
}
